import React from 'react';
import axios from 'axios';

export const API_URL = window._env_?.REACT_APP_API_URL || process.env.REACT_APP_API_URL || 'http://localhost:8000';
export const API_TOKEN = window._env_?.REACT_APP_API_TOKEN || process.env.REACT_APP_API_TOKEN;

export const api = axios.create({
  baseURL: API_URL,
  headers: { Authorization: `Bearer ${API_TOKEN}` },
});

// Classify train type using trainTypeProductCategorie + trainTypeValue
export const classifyTrainType = (journey) => {
  if (journey.trainTypeValue === 's-bahn') return 'sbahn';

  switch (journey.trainTypeProductCategorie) {
    case 'longdistance': return 'fern';
    case 'metro': return 'ubahn';
    case 'localtrain': return 'regio';
    case 'tram': return 'tram';
    case 'bus': return 'bus';
    default: return 'default';
  }
};

export const trainTypeIcons = {
  fern: (
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" viewBox="0 0 32 32">
      <rect width="28" height="28" x="2" y="2" fill="#F5D700" rx="14"/>
      <path fill="#000" fillRule="evenodd" d="M12.668 25.497h-1.643l1.179-1.997h1.644l-.311.524h4.925l-.31-.524h1.643l1.18 1.997h-1.643l-.427-.723h-5.811zM19.193 6c.06 0 .113.042.127.102l.195.819a.133.133 0 0 1-.127.165L16.4 7.085V8.5h1.062c1.929 0 3.277 1.423 3.602 3.37l.925 3.742q.015.09.01.182l-.254 4.563c-.08 1.43-2.235 2.293-3.635 2.293h-4.22c-1.4 0-3.556-.863-3.635-2.293L10 15.794a1 1 0 0 1 .01-.182l.925-3.743C11.261 9.923 12.61 8.5 14.538 8.5H15.6V7.085h-2.989a.133.133 0 0 1-.126-.164l.195-.82A.13.13 0 0 1 12.806 6z" clipRule="evenodd"/>
    </svg>
  ),
  sbahn: (
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" viewBox="0 0 32 32">
      <circle cx="16" cy="16" r="14" fill="#008D4F"/>
      <path fill="#fff" d="M25.273 19.672c0 7.51-10.409 10.242-17.828 4.567v-5.067c3.262 5.204 12.108 6.66 12.214 2.351.06-3.838-11.35-.986-12.396-10.029 0-7.48 10.53-8.785 16.675-4.066v4.279c-2.246-2.352-5.417-4.249-7.83-4.249-2.412 0-3.596.926-3.596 2.094-.03 4.537 12.76 2.443 12.76 10.12"/>
    </svg>
  ),
  regio: (
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" viewBox="0 0 32 32">
      <rect width="28" height="28" x="2" y="2" fill="#14A575" rx="14"/>
      <path fill="#fff" fillRule="evenodd" d="M9.499 25.576h4.198v-7.648h1.432c1.823 0 2.669.619 3.255 2.962.976 3.905 1.041 4.1 1.399 4.686h4.426c-.814-2.083-1.107-3.938-1.562-5.63-.553-2.018-1.107-2.897-2.636-3.58v-.13c1.822-.749 3.384-2.213 3.384-5.012 0-1.595-.488-2.896-1.757-3.873-1.237-.944-3.287-1.627-6.672-1.627-1.822 0-4.035.195-5.467.423zm4.198-10.902V9.402a8 8 0 0 1 1.887-.228c2.18 0 3.385.976 3.385 2.603 0 1.66-1.204 2.897-3.45 2.897z" clipRule="evenodd"/>
    </svg>
  ),
  tram: (
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" viewBox="0 0 32 32">
      <path fill="#F00010" d="M29 3H3v26h26z"/>
      <path fill="#fff" d="M15.843 13.639c1.573 0 2.254.738 2.254 2.129v2.33c0 .421.067.507.306.508.115 0 .222-.02.298-.039v1.276c-.23.057-.566.077-.853.077-.633 0-.998-.125-1.257-.748-.336.565-.96.805-1.602.805-1.198 0-1.793-.815-1.793-1.88h.01c0-1.102.671-1.6 1.813-1.745l1.438-.192v-.422c0-.585-.326-.796-.768-.796-.418 0-.888.123-1.518.604l-.736-1.173a4.17 4.17 0 0 1 2.408-.734m-6.09-.567H7.77v6.79H5.995v-6.79H4V11.5h5.754zm2.849.547c.172 0 .307.01.45.048v1.458a1.6 1.6 0 0 0-.421-.067c-.585 0-1.208.48-1.486 1.046v3.758h-1.66v-6.118h1.563v.987c.355-1.083 1.084-1.112 1.554-1.112m13.32.01c1.074 0 1.678.7 1.678 2.023v4.21h-1.678v-3.768c0-.787-.23-1.027-.595-1.027-.364 0-.767.221-1.074.48v4.315h-1.658v-3.768c0-.786-.221-1.027-.595-1.027-.403 0-.806.24-1.074.508v4.287h-1.66v-6.118h1.592v.796c.288-.355.825-.911 1.745-.911.71 0 1.229.336 1.478.959.393-.46.978-.96 1.84-.96m-10.193 3.538c-.7.115-.883.346-.883.806 0 .422.22.642.623.642.412 0 .73-.163.988-.364v-1.19z"/>
    </svg>
  ),
  ubahn: (
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" viewBox="0 0 32 32">
      <rect width="28" height="28" x="2" y="2" fill="#1455C0" rx="4"/>
      <path fill="#fff" d="M10.5 10v8.5c0 3.2 2.3 5.5 5.5 5.5s5.5-2.3 5.5-5.5V10h-3v8.5c0 1.4-1.1 2.5-2.5 2.5s-2.5-1.1-2.5-2.5V10z"/>
    </svg>
  ),
  bus: (
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" viewBox="0 0 32 32">
      <path fill="#C12188" fillRule="evenodd" d="m31 16-7.5 13h-15L1 16 8.5 3h15z" clipRule="evenodd"/>
      <path fill="#fff" d="M14.915 17.265c0 1.255.528 1.871 1.585 1.871s1.574-.616 1.574-1.87v-6.078h2.036v6.077c0 2.466-1.365 3.688-3.6 3.688-2.234 0-3.599-1.211-3.599-3.688h-.01v-6.077h2.014zm9.442-6.231c1.31 0 2.444.54 3.137 1.056l-.869 1.53c-.616-.583-1.464-.945-2.169-.945-.616 0-1.343.34-1.343 1.11 0 .65.506.849 1.343 1.07l.804.219c1.376.385 2.476 1.19 2.476 2.895 0 2.037-1.574 2.984-3.313 2.984s-2.84-.816-3.633-1.707h.033l1.278-1.332c.583.803 1.386 1.398 2.311 1.398.749 0 1.42-.385 1.42-1.265 0-.727-.451-.903-1.464-1.178l-.837-.22c-1.134-.31-2.29-1.08-2.29-2.775 0-1.949 1.531-2.84 3.116-2.84m-16.227.165c.442 0 3.17.001 3.17 2.323 0 .749-.199 1.453-.991 2.157 1.177.573 1.586 1.266 1.586 2.466 0 1.596-1.046 2.653-2.917 2.654H4.959v-9.6zm-1.156 7.904H8.37c1.046 0 1.476-.319 1.476-1.144l.01-.012c0-.98-.572-1.265-1.254-1.276h-1.63zm0-3.886h.88c.859.011 1.398-.242 1.398-1.244h.012c0-.572-.155-1.068-1.3-1.068h-.99z"/>
    </svg>
  ),
  default: (
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" viewBox="0 0 32 32">
      <rect width="28" height="28" x="2" y="2" fill="#6e7681" rx="14"/>
      <path fill="#fff" fillRule="evenodd" d="M9.499 25.576h4.198v-7.648h1.432c1.823 0 2.669.619 3.255 2.962.976 3.905 1.041 4.1 1.399 4.686h4.426c-.814-2.083-1.107-3.938-1.562-5.63-.553-2.018-1.107-2.897-2.636-3.58v-.13c1.822-.749 3.384-2.213 3.384-5.012 0-1.595-.488-2.896-1.757-3.873-1.237-.944-3.287-1.627-6.672-1.627-1.822 0-4.035.195-5.467.423zm4.198-10.902V9.402a8 8 0 0 1 1.887-.228c2.18 0 3.385.976 3.385 2.603 0 1.66-1.204 2.897-3.45 2.897z" clipRule="evenodd"/>
    </svg>
  ),
};

export const trainTypeColors = {
  fern: '#F5D700',
  sbahn: '#008D4F',
  ubahn: '#1455C0',
  regio: '#14A575',
  tram: '#F00010',
  bus: '#C12188',
  default: '#6e7681',
};

// Two channels, deliberately kept apart: the round symbol carries the *product* (the green S,
// the long-distance mark, the R for Regio) because that is the system passengers know from the
// platform. The label carries the *operator*, which is what tells a Flix apart from an ICE.
//
// Only brands whose colour is actually known are listed. An operator we are unsure about keeps
// the product colour — a made-up corporate green is worse than a neutral one, and on a map it
// would look just as deliberate.
//
// Order matters: the specific patterns come before the general ones, or "DB Regio" would be
// caught by the plain "DB" rule.
// Where a colour is not common knowledge it was read off the operator's own site — the value
// its stylesheet and its logo actually use — rather than picked by eye. The check is noted
// beside each one so it can be redone if a company rebrands.
const brandColors = [
  [/flix/i, '#73D700'],                                        // FlixTrain green
  // One DB, one red. An earlier version darkened it for DB Regio so a regional train would
  // not read as an ICE, but DB has a single red and inventing a second one is exactly the
  // mistake this table avoids elsewhere. Telling an ICE from an S-Bahn is the symbol's job,
  // and the symbol already does it.
  [/\bdb\b|deutsche\s*bahn|db\s*(?:fernverkehr|regio|cargo)/i, '#EC0016'],
  [/öbb|oebb/i, '#E2002A'],
  [/\bsbb\b|\bcff\b|schweizer\w*\s+bundesbahn/i, '#EB0000'],
  // arverio.de: the logo file avi-de.svg is filled #F08300, and the same value carries the
  // primary buttons and --mm-color-background-emphasis. Also answers to its former name,
  // Go-Ahead, which older rolling stock records still carry.
  [/arverio|go[-\s]?ahead/i, '#F08300'],
  // avg.info serves several brands from one template and scopes the AVG ones under
  // `body.avg`; those rules and the AVG favicon are #008939. Wikimedia describes the logo as
  // grey and green, which agrees.
  [/albtal|\bavg\b/i, '#008939'],
  // sweg.de: #004494 carries the buttons and links across 92 rules. Its favicon is a shade
  // darker (#134094) and the company publishes no style guide, so this is the site's value
  // rather than a documented brand value.
  [/\bsweg\b/i, '#004494'],
];

/**
 * Brand colour of the operator, or null when we do not know it and the product colour should
 * stand. Applies to every category, not only long distance — a regional operator has a brand
 * just as much as FlixTrain does.
 */
export const brandColorFor = (operator) => {
  if (!operator) return null;
  const hit = brandColors.find(([re]) => re.test(operator));
  return hit ? hit[1] : null;
};

/** Black on bright backgrounds (DB yellow, Flix green), white on dark ones */
export const readableTextOn = (hex) => {
  const c = String(hex).replace('#', '');
  const [r, g, b] = [0, 2, 4].map(i => parseInt(c.slice(i, i + 2), 16) / 255);
  return 0.2126 * r + 0.7152 * g + 0.0722 * b > 0.6 ? '#000000' : '#ffffff';
};

export const categoryLabels = {
  longdistance: 'Fernverkehr',
  localtrain: 'Nahverkehr',
  metro: 'U-Bahn',
  tram: 'Straßenbahn',
  bus: 'Bus',
};

export const attributeLabels = {
  BF: { label: 'Fahrradmitnahme', icon: 'fa-bicycle' },
  BR: { label: 'Bordrestaurant', icon: 'fa-cutlery' },
  BK: { label: 'Bordbistro', icon: 'fa-coffee' },
  KL: { label: 'Klimaanlage', icon: 'fa-snowflake-o' },
  WR: { label: 'WLAN', icon: 'fa-wifi' },
  HI: { label: 'Barrierefreier Zugang', icon: 'fa-wheelchair' },
  RZ: { label: 'Reservierung', icon: 'fa-ticket' },
};
